export const geoDataCR = {
    provinces: [
        {
            id: 0,
            name: 'Selecciona una provincia'
        },
        {
            id: 1,
            name: 'San José'
        },
        {
            id: 2,
            name: 'Alajuela'
        },
        {
            id: 3,
            name: 'Cartago'
        },
        {
            id: 4,
            name: 'Heredia'
        },
        {
            id: 5,
            name: 'Guanacaste'
        },
        {
            id: 6,
            name: 'Puntarenas'
        },
        {
            id: 7,
            name: 'Limón'
        }
    ],

    cantons: [
        {
            provinceId: 0,
            id: 0,
            name: 'Selecciona un cantón',
            code: 0
        },
        {
            provinceId: 1,
            id: 1,
            name: 'San José',
            code: 101
        },
        {
            provinceId: 1,
            id: 2,
            name: 'Escazú',
            code: 102
        },
        {
            provinceId: 1,
            id: 3,
            name: 'Desamparados',
            code: 103
        },
        {
            provinceId: 1,
            id: 4,
            name: 'Puriscal',
            code: 104
        },
        {
            provinceId: 1,
            id: 5,
            name: 'Tarrazú',
            code: 105
        },
        {
            provinceId: 1,
            id: 6,
            name: 'Aserrí',
            code: 106
        },
        {
            provinceId: 1,
            id: 7,
            name: 'Mora',
            code: 107
        },
        {
            provinceId: 1,
            id: 8,
            name: 'Goicoechea',
            code: 108
        },
        {
            provinceId: 1,
            id: 9,
            name: 'Santa Ana',
            code: 109
        },
        {
            provinceId: 1,
            id: 10,
            name: 'Alajuelita',
            code: 110
        },
        {
            provinceId: 1,
            id: 11,
            name: 'Vásquez de Coronado',
            code: 111
        },
        {
            provinceId: 1,
            id: 12,
            name: 'Acosta',
            code: 112
        },
        {
            provinceId: 1,
            id: 13,
            name: 'Tibás',
            code: 113
        },
        {
            provinceId: 1,
            id: 14,
            name: 'Moravia',
            code: 114
        },
        {
            provinceId: 1,
            id: 15,
            name: 'Montes de Oca',
            code: 115
        },
        {
            provinceId: 1,
            id: 16,
            name: 'Turrubares',
            code: 116
        },
        {
            provinceId: 1,
            id: 17,
            name: 'Dota',
            code: 117
        },
        {
            provinceId: 1,
            id: 18,
            name: 'Curridabat',
            code: 118
        },
        {
            provinceId: 1,
            id: 19,
            name: 'Pérez Zeledón',
            code: 119
        },
        {
            provinceId: 1,
            id: 20,
            name: 'León Cortéz',
            code: 120
        },
        {
            provinceId: 2,
            id: 1,
            name: 'Alajuela',
            code: 201
        },
        {
            provinceId: 2,
            id: 2,
            name: 'San Ramón',
            code: 202
        },
        {
            provinceId: 2,
            id: 3,
            name: 'Grecia',
            code: 203
        },
        {
            provinceId: 2,
            id: 4,
            name: 'San Mateo',
            code: 204
        },
        {
            provinceId: 2,
            id: 5,
            name: 'Atenas',
            code: 205
        },
        {
            provinceId: 2,
            id: 6,
            name: 'Naranjo',
            code: 206
        },
        {
            provinceId: 2,
            id: 7,
            name: 'Palmares',
            code: 207
        },
        {
            provinceId: 2,
            id: 8,
            name: 'Poás',
            code: 208
        },
        {
            provinceId: 2,
            id: 9,
            name: 'Orotina',
            code: 209
        },
        {
            provinceId: 2,
            id: 10,
            name: 'San Carlos',
            code: 210
        },
        {
            provinceId: 2,
            id: 11,
            name: 'Zarcero',
            code: 211
        },
        {
            provinceId: 2,
            id: 12,
            name: 'Sarchi',
            code: 212
        },
        {
            provinceId: 2,
            id: 13,
            name: 'Upala',
            code: 213
        },
        {
            provinceId: 2,
            id: 14,
            name: 'Los Chiles',
            code: 214
        },
        {
            provinceId: 2,
            id: 15,
            name: 'Guatuso',
            code: 215
        },
        {
            provinceId: 2,
            id: 16,
            name: 'Río Cuarto',
            code: 216
        },
        {
            provinceId: 3,
            id: 1,
            name: 'Cartago',
            code: 301
        },
        {
            provinceId: 3,
            id: 2,
            name: 'Paraíso',
            code: 302
        },
        {
            provinceId: 3,
            id: 3,
            name: 'La Unión',
            code: 303
        },
        {
            provinceId: 3,
            id: 4,
            name: 'Jiménez',
            code: 304
        },
        {
            provinceId: 3,
            id: 5,
            name: 'Turrialba',
            code: 305
        },
        {
            provinceId: 3,
            id: 6,
            name: 'Alvarado',
            code: 306
        },
        {
            provinceId: 3,
            id: 7,
            name: 'Oreamuno',
            code: 307
        },
        {
            provinceId: 3,
            id: 8,
            name: 'El Guarco',
            code: 308
        },
        {
            provinceId: 4,
            id: 1,
            name: 'Heredia',
            code: 401
        },
        {
            provinceId: 4,
            id: 2,
            name: 'Barva',
            code: 402
        },
        {
            provinceId: 4,
            id: 3,
            name: 'Santo Domingo',
            code: 403
        },
        {
            provinceId: 4,
            id: 4,
            name: 'Santa Bárbara',
            code: 404
        },
        {
            provinceId: 4,
            id: 5,
            name: 'San Rafael',
            code: 405
        },
        {
            provinceId: 4,
            id: 6,
            name: 'San Isidro',
            code: 406
        },
        {
            provinceId: 4,
            id: 7,
            name: 'Belén',
            code: 407
        },
        {
            provinceId: 4,
            id: 8,
            name: 'Flores',
            code: 408
        },
        {
            provinceId: 4,
            id: 9,
            name: 'San Pablo',
            code: 409
        },
        {
            provinceId: 4,
            id: 10,
            name: 'Sarapiquí',
            code: 410
        },
        {
            provinceId: 5,
            id: 1,
            name: 'Liberia',
            code: 501
        },
        {
            provinceId: 5,
            id: 2,
            name: 'Nicoya',
            code: 502
        },
        {
            provinceId: 5,
            id: 3,
            name: 'Santa Cruz',
            code: 503
        },
        {
            provinceId: 5,
            id: 4,
            name: 'Bagaces',
            code: 504
        },
        {
            provinceId: 5,
            id: 5,
            name: 'Carrillo',
            code: 505
        },
        {
            provinceId: 5,
            id: 6,
            name: 'Cañas',
            code: 506
        },
        {
            provinceId: 5,
            id: 7,
            name: 'Abangáres',
            code: 507
        },
        {
            provinceId: 5,
            id: 8,
            name: 'Tilarán',
            code: 508
        },
        {
            provinceId: 5,
            id: 9,
            name: 'Nandayure',
            code: 509
        },
        {
            provinceId: 5,
            id: 10,
            name: 'La Cruz',
            code: 510
        },
        {
            provinceId: 5,
            id: 11,
            name: 'Hojancha',
            code: 511
        },
        {
            provinceId: 6,
            id: 1,
            name: 'Puntarenas',
            code: 601
        },
        {
            provinceId: 6,
            id: 2,
            name: 'Esparza',
            code: 602
        },
        {
            provinceId: 6,
            id: 3,
            name: 'Buenos Aires',
            code: 603
        },
        {
            provinceId: 6,
            id: 4,
            name: 'Montes de Oro',
            code: 604
        },
        {
            provinceId: 6,
            id: 5,
            name: 'Osa',
            code: 605
        },
        {
            provinceId: 6,
            id: 6,
            name: 'Quepos',
            code: 606
        },
        {
            provinceId: 6,
            id: 7,
            name: 'Golfito',
            code: 607
        },
        {
            provinceId: 6,
            id: 8,
            name: 'Coto Brus',
            code: 608
        },
        {
            provinceId: 6,
            id: 9,
            name: 'Parrita',
            code: 609
        },
        {
            provinceId: 6,
            id: 10,
            name: 'Corredores',
            code: 610
        },
        {
            provinceId: 6,
            id: 11,
            name: 'Garabito',
            code: 611
        },
        {
            provinceId: 6,
            id: 12,
            name: 'Monte verde',
            code: 612
        },
        {
            provinceId: 6,
            id: 13,
            name: 'Puerto Jiménez',
            code: 613
        },
        {
            provinceId: 7,
            id: 1,
            name: 'Limón',
            code: 701
        },
        {
            provinceId: 7,
            id: 2,
            name: 'Pococí',
            code: 702
        },
        {
            provinceId: 7,
            id: 3,
            name: 'Siquirres',
            code: 703
        },
        {
            provinceId: 7,
            id: 4,
            name: 'Talamanca',
            code: 704
        },
        {
            provinceId: 7,
            id: 5,
            name: 'Matina',
            code: 705
        },
        {
            provinceId: 7,
            id: 6,
            name: 'Guácimo',
            code: 706
        }
    ],

    districts: [
        {
            provinceId: 0,
            cantonId: 0,
            id: 0,
            code: 0,
            name: 'Selecciona un distrito'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 1,
            code: 10101,
            name: 'Carmen'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 2,
            code: 10102,
            name: 'Merced'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 3,
            code: 10103,
            name: 'Hospital'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 4,
            code: 10104,
            name: 'Catedral'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 5,
            code: 10105,
            name: 'Zapote'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 6,
            code: 10106,
            name: 'San Francisco de Dos Ríos'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 7,
            code: 10107,
            name: 'Uruca'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 8,
            code: 10108,
            name: 'Mata Redonda'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 9,
            code: 10109,
            name: 'Pavas'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 10,
            code: 10110,
            name: 'Hatillo'
        },
        {
            provinceId: 1,
            cantonId: 1,
            id: 11,
            code: 10111,
            name: 'San Sebastián'
        },
        {
            provinceId: 1,
            cantonId: 2,
            id: 1,
            code: 10201,
            name: 'Escazú'
        },
        {
            provinceId: 1,
            cantonId: 2,
            id: 2,
            code: 10202,
            name: 'San Antonio'
        },
        {
            provinceId: 1,
            cantonId: 2,
            id: 3,
            code: 10203,
            name: 'San Rafael'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 1,
            code: 10301,
            name: 'Desamparados'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 2,
            code: 10302,
            name: 'San Miguel'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 3,
            code: 10303,
            name: 'San Juan de Dios'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 4,
            code: 10304,
            name: 'San Rafael Arriba'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 5,
            code: 10305,
            name: 'San Antonio'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 6,
            code: 10306,
            name: 'Frailes'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 7,
            code: 10307,
            name: 'Patarrá'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 8,
            code: 10308,
            name: 'San Cristóbal'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 9,
            code: 10309,
            name: 'Rosario'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 10,
            code: 10310,
            name: 'Damas'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 11,
            code: 10311,
            name: 'San Rafael Abajo'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 12,
            code: 10312,
            name: 'Gravilias'
        },
        {
            provinceId: 1,
            cantonId: 3,
            id: 13,
            code: 10313,
            name: 'Los Guido'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 1,
            code: 10401,
            name: 'Santiago'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 2,
            code: 10402,
            name: 'Mercedes Sur'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 3,
            code: 10403,
            name: 'Barbacoas'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 4,
            code: 10404,
            name: 'Grifo Alto'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 5,
            code: 10405,
            name: 'San Rafael'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 6,
            code: 10406,
            name: 'Candelarita'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 7,
            code: 10407,
            name: 'Desamparaditos'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 8,
            code: 10408,
            name: 'San Antonio'
        },
        {
            provinceId: 1,
            cantonId: 4,
            id: 9,
            code: 10409,
            name: 'Chires'
        },
        {
            provinceId: 1,
            cantonId: 5,
            id: 1,
            code: 10501,
            name: 'San Marcos'
        },
        {
            provinceId: 1,
            cantonId: 5,
            id: 2,
            code: 10502,
            name: 'San Lorenzo'
        },
        {
            provinceId: 1,
            cantonId: 5,
            id: 3,
            code: 10503,
            name: 'San Carlos'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 1,
            code: 10601,
            name: 'Aserri'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 2,
            code: 10602,
            name: 'Tarbaca'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 3,
            code: 10603,
            name: 'Vuelta de Jorco'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 4,
            code: 10604,
            name: 'San Gabriel'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 5,
            code: 10605,
            name: 'Legua'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 6,
            code: 10606,
            name: 'Monterrey'
        },
        {
            provinceId: 1,
            cantonId: 6,
            id: 7,
            code: 10607,
            name: 'Salitrillos'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 1,
            code: 10701,
            name: 'Colón'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 2,
            code: 10702,
            name: 'Guayabo'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 3,
            code: 10703,
            name: 'Tabarcia'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 4,
            code: 10704,
            name: 'Piedras Negras'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 5,
            code: 10705,
            name: 'Picagres'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 6,
            code: 10706,
            name: 'Jaris'
        },
        {
            provinceId: 1,
            cantonId: 7,
            id: 7,
            code: 10707,
            name: 'Quitirrisi'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 1,
            code: 10801,
            name: 'Guadalupe'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 2,
            code: 10802,
            name: 'San Francisco'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 3,
            code: 10803,
            name: 'Calle Blancos'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 4,
            code: 10804,
            name: 'Mata de Plátano'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 5,
            code: 10805,
            name: 'Ipís'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 6,
            code: 10806,
            name: 'Rancho Redondo'
        },
        {
            provinceId: 1,
            cantonId: 8,
            id: 7,
            code: 10807,
            name: 'Purral'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 1,
            code: 10901,
            name: 'Santa Ana'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 2,
            code: 10902,
            name: 'Salitral'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 3,
            code: 10903,
            name: 'Pozos'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 4,
            code: 10904,
            name: 'Uruca'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 5,
            code: 10905,
            name: 'Piedades'
        },
        {
            provinceId: 1,
            cantonId: 9,
            id: 6,
            code: 10906,
            name: 'Brasil'
        },
        {
            provinceId: 1,
            cantonId: 10,
            id: 1,
            code: 11001,
            name: 'Alajuelita'
        },
        {
            provinceId: 1,
            cantonId: 10,
            id: 2,
            code: 11002,
            name: 'San Josecito'
        },
        {
            provinceId: 1,
            cantonId: 10,
            id: 3,
            code: 11003,
            name: 'San Antonio'
        },
        {
            provinceId: 1,
            cantonId: 10,
            id: 4,
            code: 11004,
            name: 'Concepción'
        },
        {
            provinceId: 1,
            cantonId: 10,
            id: 5,
            code: 11005,
            name: 'San Felipe'
        },
        {
            provinceId: 1,
            cantonId: 11,
            id: 1,
            code: 11101,
            name: 'San Isidro'
        },
        {
            provinceId: 1,
            cantonId: 11,
            id: 2,
            code: 11102,
            name: 'San Rafael'
        },
        {
            provinceId: 1,
            cantonId: 11,
            id: 3,
            code: 11103,
            name: 'Dulce Nombre de Jesús'
        },
        {
            provinceId: 1,
            cantonId: 11,
            id: 4,
            code: 11104,
            name: 'Patalillo'
        },
        {
            provinceId: 1,
            cantonId: 11,
            id: 5,
            code: 11105,
            name: 'Cascajal'
        },
        {
            provinceId: 1,
            cantonId: 12,
            id: 1,
            code: 11201,
            name: 'San Ignacio'
        },
        {
            provinceId: 1,
            cantonId: 12,
            id: 2,
            code: 11202,
            name: 'Guaitil Villa'
        },
        {
            provinceId: 1,
            cantonId: 12,
            id: 3,
            code: 11203,
            name: 'Palmichal'
        },
        {
            provinceId: 1,
            cantonId: 12,
            id: 4,
            code: 11204,
            name: 'Cangrejal'
        },
        {
            provinceId: 1,
            cantonId: 12,
            id: 5,
            code: 11205,
            name: 'Sabanillas'
        },
        {
            provinceId: 1,
            cantonId: 13,
            id: 1,
            code: 11301,
            name: 'San Juan'
        },
        {
            provinceId: 1,
            cantonId: 13,
            id: 2,
            code: 11302,
            name: 'Cinco Esquinas'
        },
        {
            provinceId: 1,
            cantonId: 13,
            id: 3,
            code: 11303,
            name: 'Anselmo llorente'
        },
        {
            provinceId: 1,
            cantonId: 13,
            id: 4,
            code: 11304,
            name: 'Leon xiii'
        },
        {
            provinceId: 1,
            cantonId: 13,
            id: 5,
            code: 11305,
            name: 'Colima'
        },
        {
            provinceId: 1,
            cantonId: 14,
            id: 1,
            code: 11401,
            name: 'San Vicente'
        },
        {
            provinceId: 1,
            cantonId: 14,
            id: 2,
            code: 11402,
            name: 'San Jerónimo'
        },
        {
            provinceId: 1,
            cantonId: 14,
            id: 3,
            code: 11403,
            name: 'La Trinidad'
        },
        {
            provinceId: 1,
            cantonId: 15,
            id: 1,
            code: 11501,
            name: 'San Pedro'
        },
        {
            provinceId: 1,
            cantonId: 15,
            id: 2,
            code: 11502,
            name: 'Sabanilla'
        },
        {
            provinceId: 1,
            cantonId: 15,
            id: 3,
            code: 11503,
            name: 'Mercedes'
        },
        {
            provinceId: 1,
            cantonId: 15,
            id: 4,
            code: 11504,
            name: 'San Rafael'
        },
        {
            provinceId: 1,
            cantonId: 16,
            id: 1,
            code: 11601,
            name: 'San Pablo'
        },
        {
            provinceId: 1,
            cantonId: 16,
            id: 2,
            code: 11602,
            name: 'San Pedro'
        },
        {
            provinceId: 1,
            cantonId: 16,
            id: 3,
            code: 11603,
            name: 'San Juan de Mata'
        },
        {
            provinceId: 1,
            cantonId: 16,
            id: 4,
            code: 11604,
            name: 'San luis'
        },
        {
            provinceId: 1,
            cantonId: 16,
            id: 5,
            code: 11605,
            name: 'Carara'
        },
        {
            provinceId: 1,
            cantonId: 17,
            id: 1,
            code: 11701,
            name: 'Santa María'
        },
        {
            provinceId: 1,
            cantonId: 17,
            id: 2,
            code: 11702,
            name: 'Jardín'
        },
        {
            provinceId: 1,
            cantonId: 17,
            id: 3,
            code: 11703,
            name: 'Copey'
        },
        {
            provinceId: 1,
            cantonId: 18,
            id: 1,
            code: 11801,
            name: 'Curridabat'
        },
        {
            provinceId: 1,
            cantonId: 18,
            id: 2,
            code: 11802,
            name: 'Granadilla'
        },
        {
            provinceId: 1,
            cantonId: 18,
            id: 3,
            code: 11803,
            name: 'Sánchez'
        },
        {
            provinceId: 1,
            cantonId: 18,
            id: 4,
            code: 11804,
            name: 'Tirrases'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 1,
            code: 11901,
            name: 'San Isidro de El General'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 2,
            code: 11902,
            name: 'El General'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 3,
            code: 11903,
            name: 'Daniel Flores'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 4,
            code: 11904,
            name: 'Rivas'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 5,
            code: 11905,
            name: 'San Pedro'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 6,
            code: 11906,
            name: 'Platanares'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 7,
            code: 11907,
            name: 'Pejibaye'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 8,
            code: 11908,
            name: 'Cajón'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 9,
            code: 11909,
            name: 'Barú'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 10,
            code: 11910,
            name: 'Río Nuevo'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 11,
            code: 11911,
            name: 'Páramo'
        },
        {
            provinceId: 1,
            cantonId: 19,
            id: 12,
            code: 11912,
            name: 'La Amistad'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 1,
            code: 12001,
            name: 'San Pablo'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 2,
            code: 12002,
            name: 'San Andrés'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 3,
            code: 12003,
            name: 'Llano Bonito'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 4,
            code: 12004,
            name: 'San Isidro'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 5,
            code: 12005,
            name: 'Santa Cruz'
        },
        {
            provinceId: 1,
            cantonId: 20,
            id: 6,
            code: 12006,
            name: 'San Antonio'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 1,
            code: 20101,
            name: 'Alajuela'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 2,
            code: 20102,
            name: 'San José'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 3,
            code: 20103,
            name: 'Carrizal'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 4,
            code: 20104,
            name: 'San Antonio'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 5,
            code: 20105,
            name: 'Guácima'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 6,
            code: 20106,
            name: 'San Isidro'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 7,
            code: 20107,
            name: 'Sabanilla'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 8,
            code: 20108,
            name: 'San Rafael'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 9,
            code: 20109,
            name: 'Río Segundo'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 10,
            code: 20110,
            name: 'Desamparados'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 11,
            code: 20111,
            name: 'Turrúcares'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 12,
            code: 20112,
            name: 'Tambor'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 13,
            code: 20113,
            name: 'Garita'
        },
        {
            provinceId: 2,
            cantonId: 1,
            id: 14,
            code: 20114,
            name: 'Sarapiquí'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 1,
            code: 20201,
            name: 'San Ramón'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 2,
            code: 20202,
            name: 'Santiago'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 3,
            code: 20203,
            name: 'San Juan'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 4,
            code: 20204,
            name: 'Piedades Norte'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 5,
            code: 20205,
            name: 'Piedades Sur'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 6,
            code: 20206,
            name: 'San Rafael'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 7,
            code: 20207,
            name: 'San Isidro'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 8,
            code: 20208,
            name: 'Ángeles'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 9,
            code: 20209,
            name: 'Alfaro'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 10,
            code: 20210,
            name: 'Volio'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 11,
            code: 20211,
            name: 'Concepción'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 12,
            code: 20212,
            name: 'Zapotal'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 13,
            code: 20213,
            name: 'Peñas Blancas'
        },
        {
            provinceId: 2,
            cantonId: 2,
            id: 14,
            code: 20214,
            name: 'San Lorenzo'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 1,
            code: 20301,
            name: 'Grecia'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 2,
            code: 20302,
            name: 'San Isidro'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 3,
            code: 20303,
            name: 'San José'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 4,
            code: 20304,
            name: 'San Roque'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 5,
            code: 20305,
            name: 'Tacares'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 6,
            code: 20306,
            name: 'Río Cuarto'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 7,
            code: 20307,
            name: 'Puente de Piedra'
        },
        {
            provinceId: 2,
            cantonId: 3,
            id: 8,
            code: 20308,
            name: 'Bolívar'
        },
        {
            provinceId: 2,
            cantonId: 4,
            id: 1,
            code: 20401,
            name: 'San Mateo'
        },
        {
            provinceId: 2,
            cantonId: 4,
            id: 2,
            code: 20402,
            name: 'Desmonte'
        },
        {
            provinceId: 2,
            cantonId: 4,
            id: 3,
            code: 20403,
            name: 'Jesús María'
        },
        {
            provinceId: 2,
            cantonId: 4,
            id: 4,
            code: 20404,
            name: 'Labrador'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 1,
            code: 20501,
            name: 'Atenas'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 2,
            code: 20502,
            name: 'Jesús'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 3,
            code: 20503,
            name: 'Mercedes'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 4,
            code: 20504,
            name: 'San Isidro'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 5,
            code: 20505,
            name: 'Concepción'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 6,
            code: 20506,
            name: 'San Jose'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 7,
            code: 20507,
            name: 'Santa Eulalia'
        },
        {
            provinceId: 2,
            cantonId: 5,
            id: 8,
            code: 20508,
            name: 'Escobal'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 1,
            code: 20601,
            name: 'Naranjo'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 2,
            code: 20602,
            name: 'San Miguel'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 3,
            code: 20603,
            name: 'San José'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 4,
            code: 20604,
            name: 'Cirrí Sur'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 5,
            code: 20605,
            name: 'San Jerónimo'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 6,
            code: 20606,
            name: 'San Juan'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 7,
            code: 20607,
            name: 'El Rosario'
        },
        {
            provinceId: 2,
            cantonId: 6,
            id: 8,
            code: 20608,
            name: 'Palmitos'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 1,
            code: 20701,
            name: 'Palmares'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 2,
            code: 20702,
            name: 'Zaragoza'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 3,
            code: 20703,
            name: 'Buenos Aires'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 4,
            code: 20704,
            name: 'Santiago'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 5,
            code: 20705,
            name: 'Candelaria'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 6,
            code: 20706,
            name: 'Esquípulas'
        },
        {
            provinceId: 2,
            cantonId: 7,
            id: 7,
            code: 20707,
            name: 'La Granja'
        },
        {
            provinceId: 2,
            cantonId: 8,
            id: 1,
            code: 20801,
            name: 'San Pedro'
        },
        {
            provinceId: 2,
            cantonId: 8,
            id: 2,
            code: 20802,
            name: 'San Juan'
        },
        {
            provinceId: 2,
            cantonId: 8,
            id: 3,
            code: 20803,
            name: 'San Rafael'
        },
        {
            provinceId: 2,
            cantonId: 8,
            id: 4,
            code: 20804,
            name: 'Carrillos'
        },
        {
            provinceId: 2,
            cantonId: 8,
            id: 5,
            code: 20805,
            name: 'Sabana Redonda'
        },
        {
            provinceId: 2,
            cantonId: 9,
            id: 1,
            code: 20901,
            name: 'Orotina'
        },
        {
            provinceId: 2,
            cantonId: 9,
            id: 2,
            code: 20902,
            name: 'El Mastate'
        },
        {
            provinceId: 2,
            cantonId: 9,
            id: 3,
            code: 20903,
            name: 'Hacienda Vieja'
        },
        {
            provinceId: 2,
            cantonId: 9,
            id: 4,
            code: 20904,
            name: 'Coyolar'
        },
        {
            provinceId: 2,
            cantonId: 9,
            id: 5,
            code: 20905,
            name: 'La Ceiba'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 1,
            code: 21001,
            name: 'Quesada'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 2,
            code: 21002,
            name: 'Florencia'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 3,
            code: 21003,
            name: 'Buenavista'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 4,
            code: 21004,
            name: 'Aguas Zarcas'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 5,
            code: 21005,
            name: 'Venecia'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 6,
            code: 21006,
            name: 'Pital'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 7,
            code: 21007,
            name: 'La Fortuna'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 8,
            code: 21008,
            name: 'La Tigra'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 9,
            code: 21009,
            name: 'La Palmera'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 10,
            code: 21010,
            name: 'Venado'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 11,
            code: 21011,
            name: 'Cutris'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 12,
            code: 21012,
            name: 'Monterrey'
        },
        {
            provinceId: 2,
            cantonId: 10,
            id: 13,
            code: 21013,
            name: 'Pocosol'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 1,
            code: 21101,
            name: 'Zarcero'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 2,
            code: 21102,
            name: 'Laguna'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 3,
            code: 21103,
            name: 'Tapezco'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 4,
            code: 21104,
            name: 'Guadalupe'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 5,
            code: 21105,
            name: 'Palmira'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 6,
            code: 21106,
            name: 'Zapote'
        },
        {
            provinceId: 2,
            cantonId: 11,
            id: 7,
            code: 21107,
            name: 'Brisas'
        },
        {
            provinceId: 2,
            cantonId: 12,
            id: 1,
            code: 21201,
            name: 'Sarchí Norte'
        },
        {
            provinceId: 2,
            cantonId: 12,
            id: 2,
            code: 21202,
            name: 'Sarchí Sur'
        },
        {
            provinceId: 2,
            cantonId: 12,
            id: 3,
            code: 21203,
            name: 'Toro Amarillo'
        },
        {
            provinceId: 2,
            cantonId: 12,
            id: 4,
            code: 21204,
            name: 'San Pedro'
        },
        {
            provinceId: 2,
            cantonId: 12,
            id: 5,
            code: 21205,
            name: 'Rodríguez'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 1,
            code: 21301,
            name: 'Upala'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 2,
            code: 21302,
            name: 'Aguas Claras'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 3,
            code: 21303,
            name: 'San José o Pizote'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 4,
            code: 21304,
            name: 'Bijagua'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 5,
            code: 21305,
            name: 'Delicias'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 6,
            code: 21306,
            name: 'Dos Ríos'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 7,
            code: 21307,
            name: 'Yolillal'
        },
        {
            provinceId: 2,
            cantonId: 13,
            id: 8,
            code: 21308,
            name: 'Canalete'
        },
        {
            provinceId: 2,
            cantonId: 14,
            id: 1,
            code: 21401,
            name: 'Los Chiles'
        },
        {
            provinceId: 2,
            cantonId: 14,
            id: 2,
            code: 21402,
            name: 'Caño Negro'
        },
        {
            provinceId: 2,
            cantonId: 14,
            id: 3,
            code: 21403,
            name: 'El Amparo'
        },
        {
            provinceId: 2,
            cantonId: 14,
            id: 4,
            code: 21404,
            name: 'San Jorge'
        },
        {
            provinceId: 2,
            cantonId: 15,
            id: 1,
            code: 21501,
            name: 'San Rafael'
        },
        {
            provinceId: 2,
            cantonId: 15,
            id: 2,
            code: 21502,
            name: 'Buenavista'
        },
        {
            provinceId: 2,
            cantonId: 15,
            id: 3,
            code: 21503,
            name: 'Cote'
        },
        {
            provinceId: 2,
            cantonId: 15,
            id: 4,
            code: 21504,
            name: 'Katira'
        },
        {
            provinceId: 2,
            cantonId: 16,
            id: 1,
            code: 21601,
            name: 'Río Cuarto'
        },
        {
            provinceId: 2,
            cantonId: 16,
            id: 2,
            code: 21602,
            name: 'Santa Rita'
        },
        {
            provinceId: 2,
            cantonId: 16,
            id: 3,
            code: 21603,
            name: 'Santa Isabel'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 1,
            code: 30101,
            name: 'Oriental'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 2,
            code: 30102,
            name: 'Occidental'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 3,
            code: 30103,
            name: 'Carmen'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 4,
            code: 30104,
            name: 'San Nicolás'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 5,
            code: 30105,
            name: 'Aguacaliente o San Francisco'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 6,
            code: 30106,
            name: 'Guadalupe o Arenilla'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 7,
            code: 30107,
            name: 'Corralillo'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 8,
            code: 30108,
            name: 'Tierra Blanca'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 9,
            code: 30109,
            name: 'Dulce Nombre'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 10,
            code: 30110,
            name: 'Llano Grande'
        },
        {
            provinceId: 3,
            cantonId: 1,
            id: 11,
            code: 30111,
            name: 'Quebradilla'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 1,
            code: 30201,
            name: 'Paraíso'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 2,
            code: 30202,
            name: 'Santiago'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 3,
            code: 30203,
            name: 'Orosi'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 4,
            code: 30204,
            name: 'Cachí'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 5,
            code: 30205,
            name: 'Llanos de Santa lucía'
        },
        {
            provinceId: 3,
            cantonId: 2,
            id: 6,
            code: 30206,
            name: 'Birrisito'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 1,
            code: 30301,
            name: 'Tres Ríos'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 2,
            code: 30302,
            name: 'San Diego'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 3,
            code: 30303,
            name: 'San Juan'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 4,
            code: 30304,
            name: 'San Rafael'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 5,
            code: 30305,
            name: 'Concepción'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 6,
            code: 30306,
            name: 'Dulce Nombre'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 7,
            code: 30307,
            name: 'San Ramón'
        },
        {
            provinceId: 3,
            cantonId: 3,
            id: 8,
            code: 30308,
            name: 'Río Azul'
        },
        {
            provinceId: 3,
            cantonId: 4,
            id: 1,
            code: 30401,
            name: 'Juan Viñas'
        },
        {
            provinceId: 3,
            cantonId: 4,
            id: 2,
            code: 30402,
            name: 'Tucurrique'
        },
        {
            provinceId: 3,
            cantonId: 4,
            id: 3,
            code: 30403,
            name: 'Pejibaye'
        },
        {
            provinceId: 3,
            cantonId: 4,
            id: 4,
            code: 30404,
            name: 'La victoria'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 1,
            code: 30501,
            name: 'Turrialba'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 2,
            code: 30502,
            name: 'La Suiza'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 3,
            code: 30503,
            name: 'Peralta'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 4,
            code: 30504,
            name: 'Santa Cruz'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 5,
            code: 30505,
            name: 'Santa Teresita'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 6,
            code: 30506,
            name: 'Pavones'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 7,
            code: 30507,
            name: 'Tuis'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 8,
            code: 30508,
            name: 'Tayutic'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 9,
            code: 30509,
            name: 'Santa Rosa'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 10,
            code: 30510,
            name: 'Tres Equis'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 11,
            code: 30511,
            name: 'La Isabel'
        },
        {
            provinceId: 3,
            cantonId: 5,
            id: 12,
            code: 30512,
            name: 'Chirripó'
        },
        {
            provinceId: 3,
            cantonId: 6,
            id: 1,
            code: 30601,
            name: 'Pacayas'
        },
        {
            provinceId: 3,
            cantonId: 6,
            id: 2,
            code: 30602,
            name: 'Cervantes'
        },
        {
            provinceId: 3,
            cantonId: 6,
            id: 3,
            code: 30603,
            name: 'Capellades'
        },
        {
            provinceId: 3,
            cantonId: 7,
            id: 1,
            code: 30701,
            name: 'San Rafael'
        },
        {
            provinceId: 3,
            cantonId: 7,
            id: 2,
            code: 30702,
            name: 'Cot'
        },
        {
            provinceId: 3,
            cantonId: 7,
            id: 3,
            code: 30703,
            name: 'Potrero Cerrado'
        },
        {
            provinceId: 3,
            cantonId: 7,
            id: 4,
            code: 30704,
            name: 'Cipreses'
        },
        {
            provinceId: 3,
            cantonId: 7,
            id: 5,
            code: 30705,
            name: 'Santa Rosa'
        },
        {
            provinceId: 3,
            cantonId: 8,
            id: 1,
            code: 30801,
            name: 'El Tejar'
        },
        {
            provinceId: 3,
            cantonId: 8,
            id: 2,
            code: 30802,
            name: 'San Isidro'
        },
        {
            provinceId: 3,
            cantonId: 8,
            id: 3,
            code: 30803,
            name: 'Tobosi'
        },
        {
            provinceId: 3,
            cantonId: 8,
            id: 4,
            code: 30804,
            name: 'Patio de Agua'
        },
        {
            provinceId: 4,
            cantonId: 1,
            id: 1,
            code: 40101,
            name: 'Heredia'
        },
        {
            provinceId: 4,
            cantonId: 1,
            id: 2,
            code: 40102,
            name: 'Mercedes'
        },
        {
            provinceId: 4,
            cantonId: 1,
            id: 3,
            code: 40103,
            name: 'San Francisco'
        },
        {
            provinceId: 4,
            cantonId: 1,
            id: 4,
            code: 40104,
            name: 'Ulloa'
        },
        {
            provinceId: 4,
            cantonId: 1,
            id: 5,
            code: 40105,
            name: 'Varablanca'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 1,
            code: 40201,
            name: 'Barva'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 2,
            code: 40202,
            name: 'San Pedro'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 3,
            code: 40203,
            name: 'San Pablo'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 4,
            code: 40204,
            name: 'San Roque'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 5,
            code: 40205,
            name: 'Santa lucía'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 6,
            code: 40206,
            name: 'San José de la Montaña'
        },
        {
            provinceId: 4,
            cantonId: 2,
            id: 7,
            code: 40207,
            name: 'Puente Salas'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 1,
            code: 40301,
            name: 'Santo Domingo'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 2,
            code: 40302,
            name: 'San Vicente'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 3,
            code: 40303,
            name: 'San Miguel'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 4,
            code: 40304,
            name: 'Paracito'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 5,
            code: 40305,
            name: 'Santo Tomás'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 6,
            code: 40306,
            name: 'Santa Rosa'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 7,
            code: 40307,
            name: 'Tures'
        },
        {
            provinceId: 4,
            cantonId: 3,
            id: 8,
            code: 40308,
            name: 'Pará'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 1,
            code: 40401,
            name: 'Santa Bárbara'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 2,
            code: 40402,
            name: 'San Pedro'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 3,
            code: 40403,
            name: 'San Juan'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 4,
            code: 40404,
            name: 'Jesús'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 5,
            code: 40405,
            name: 'Santo Domingo'
        },
        {
            provinceId: 4,
            cantonId: 4,
            id: 6,
            code: 40406,
            name: 'Purabá'
        },
        {
            provinceId: 4,
            cantonId: 5,
            id: 1,
            code: 40501,
            name: 'San Rafael'
        },
        {
            provinceId: 4,
            cantonId: 5,
            id: 2,
            code: 40502,
            name: 'San Josecito'
        },
        {
            provinceId: 4,
            cantonId: 5,
            id: 3,
            code: 40503,
            name: 'Santiago'
        },
        {
            provinceId: 4,
            cantonId: 5,
            id: 4,
            code: 40504,
            name: 'Ángeles'
        },
        {
            provinceId: 4,
            cantonId: 5,
            id: 5,
            code: 40505,
            name: 'Concepción'
        },
        {
            provinceId: 4,
            cantonId: 6,
            id: 1,
            code: 40601,
            name: 'San Isidro'
        },
        {
            provinceId: 4,
            cantonId: 6,
            id: 2,
            code: 40602,
            name: 'San José'
        },
        {
            provinceId: 4,
            cantonId: 6,
            id: 3,
            code: 40603,
            name: 'Concepción'
        },
        {
            provinceId: 4,
            cantonId: 6,
            id: 4,
            code: 40604,
            name: 'San Francisco'
        },
        {
            provinceId: 4,
            cantonId: 7,
            id: 1,
            code: 40701,
            name: 'San Antonio'
        },
        {
            provinceId: 4,
            cantonId: 7,
            id: 2,
            code: 40702,
            name: 'La Ribera'
        },
        {
            provinceId: 4,
            cantonId: 7,
            id: 3,
            code: 40703,
            name: 'La Asunción'
        },
        {
            provinceId: 4,
            cantonId: 8,
            id: 1,
            code: 40801,
            name: 'San Joaquín'
        },
        {
            provinceId: 4,
            cantonId: 8,
            id: 2,
            code: 40802,
            name: 'Barrantes'
        },
        {
            provinceId: 4,
            cantonId: 8,
            id: 3,
            code: 40803,
            name: 'Llorente'
        },
        {
            provinceId: 4,
            cantonId: 9,
            id: 1,
            code: 40901,
            name: 'San Pablo'
        },
        {
            provinceId: 4,
            cantonId: 9,
            id: 2,
            code: 40902,
            name: 'Rincón de la Sabanilla'
        },
        {
            provinceId: 4,
            cantonId: 10,
            id: 1,
            code: 41001,
            name: 'Puerto Viejo'
        },
        {
            provinceId: 4,
            cantonId: 10,
            id: 2,
            code: 41002,
            name: 'La Virgen'
        },
        {
            provinceId: 4,
            cantonId: 10,
            id: 3,
            code: 41003,
            name: 'Las Horquetas'
        },
        {
            provinceId: 4,
            cantonId: 10,
            id: 4,
            code: 41004,
            name: 'Llanuras Del Gaspar'
        },
        {
            provinceId: 4,
            cantonId: 10,
            id: 5,
            code: 41005,
            name: 'Cureña'
        },
        {
            provinceId: 5,
            cantonId: 1,
            id: 1,
            code: 50101,
            name: 'Liberia'
        },
        {
            provinceId: 5,
            cantonId: 1,
            id: 2,
            code: 50102,
            name: 'Cañas Dulces'
        },
        {
            provinceId: 5,
            cantonId: 1,
            id: 3,
            code: 50103,
            name: 'Mayorga'
        },
        {
            provinceId: 5,
            cantonId: 1,
            id: 4,
            code: 50104,
            name: 'Nacascolo'
        },
        {
            provinceId: 5,
            cantonId: 1,
            id: 5,
            code: 50105,
            name: 'Curubandé'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 1,
            code: 50201,
            name: 'Nicoya'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 2,
            code: 50202,
            name: 'Mansión'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 3,
            code: 50203,
            name: 'San Antonio'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 4,
            code: 50204,
            name: 'Quebrada Honda'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 5,
            code: 50205,
            name: 'Sámara'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 6,
            code: 50206,
            name: 'Nosara'
        },
        {
            provinceId: 5,
            cantonId: 2,
            id: 7,
            code: 50207,
            name: 'Belén de Nosarita'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 1,
            code: 50301,
            name: 'Santa Cruz'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 2,
            code: 50302,
            name: 'Bolsón'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 3,
            code: 50303,
            name: 'Veintisiete de Abril'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 4,
            code: 50304,
            name: 'Tempate'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 5,
            code: 50305,
            name: 'Cartagena'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 6,
            code: 50306,
            name: 'Cuajiniquil'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 7,
            code: 50307,
            name: 'Diriá'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 8,
            code: 50308,
            name: 'Cabo Velas'
        },
        {
            provinceId: 5,
            cantonId: 3,
            id: 9,
            code: 50309,
            name: 'Tamarindo'
        },
        {
            provinceId: 5,
            cantonId: 4,
            id: 1,
            code: 50401,
            name: 'Bagaces'
        },
        {
            provinceId: 5,
            cantonId: 4,
            id: 2,
            code: 50402,
            name: 'La Fortuna'
        },
        {
            provinceId: 5,
            cantonId: 4,
            id: 3,
            code: 50403,
            name: 'Mogote'
        },
        {
            provinceId: 5,
            cantonId: 4,
            id: 4,
            code: 50404,
            name: 'Río Naranjo'
        },
        {
            provinceId: 5,
            cantonId: 5,
            id: 1,
            code: 50501,
            name: 'Filadelfia'
        },
        {
            provinceId: 5,
            cantonId: 5,
            id: 2,
            code: 50502,
            name: 'Palmira'
        },
        {
            provinceId: 5,
            cantonId: 5,
            id: 3,
            code: 50503,
            name: 'Sardinal'
        },
        {
            provinceId: 5,
            cantonId: 5,
            id: 4,
            code: 50504,
            name: 'Belén'
        },
        {
            provinceId: 5,
            cantonId: 6,
            id: 1,
            code: 50601,
            name: 'Cañas'
        },
        {
            provinceId: 5,
            cantonId: 6,
            id: 2,
            code: 50602,
            name: 'Palmira'
        },
        {
            provinceId: 5,
            cantonId: 6,
            id: 3,
            code: 50603,
            name: 'San Miguel'
        },
        {
            provinceId: 5,
            cantonId: 6,
            id: 4,
            code: 50604,
            name: 'Bebedero'
        },
        {
            provinceId: 5,
            cantonId: 6,
            id: 5,
            code: 50605,
            name: 'Porozal'
        },
        {
            provinceId: 5,
            cantonId: 7,
            id: 1,
            code: 50701,
            name: 'Las Juntas'
        },
        {
            provinceId: 5,
            cantonId: 7,
            id: 2,
            code: 50702,
            name: 'Sierra'
        },
        {
            provinceId: 5,
            cantonId: 7,
            id: 3,
            code: 50703,
            name: 'San Juan'
        },
        {
            provinceId: 5,
            cantonId: 7,
            id: 4,
            code: 50704,
            name: 'Colorado'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 1,
            code: 50801,
            name: 'Tilarán'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 2,
            code: 50802,
            name: 'Quebrada Grande'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 3,
            code: 50803,
            name: 'Tronadora'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 4,
            code: 50804,
            name: 'Santa Rosa'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 5,
            code: 50805,
            name: 'Líbano'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 6,
            code: 50806,
            name: 'Tierras Morenas'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 7,
            code: 50807,
            name: 'Arenal'
        },
        {
            provinceId: 5,
            cantonId: 8,
            id: 8,
            code: 50808,
            name: 'Cabeceras'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 1,
            code: 50901,
            name: 'Carmona'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 2,
            code: 50902,
            name: 'Santa Rita'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 3,
            code: 50903,
            name: 'Zapotal'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 4,
            code: 50904,
            name: 'San Pablo'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 5,
            code: 50905,
            name: 'Porvenir'
        },
        {
            provinceId: 5,
            cantonId: 9,
            id: 6,
            code: 50906,
            name: 'Bejuco'
        },
        {
            provinceId: 5,
            cantonId: 10,
            id: 1,
            code: 51001,
            name: 'La Cruz'
        },
        {
            provinceId: 5,
            cantonId: 10,
            id: 2,
            code: 51002,
            name: 'Santa Cecilia'
        },
        {
            provinceId: 5,
            cantonId: 10,
            id: 3,
            code: 51003,
            name: 'La Garita'
        },
        {
            provinceId: 5,
            cantonId: 10,
            id: 4,
            code: 51004,
            name: 'Santa Elena'
        },
        {
            provinceId: 5,
            cantonId: 11,
            id: 1,
            code: 51101,
            name: 'Hojancha'
        },
        {
            provinceId: 5,
            cantonId: 11,
            id: 2,
            code: 51102,
            name: 'Monte Romo'
        },
        {
            provinceId: 5,
            cantonId: 11,
            id: 3,
            code: 51103,
            name: 'Puerto Carrillo'
        },
        {
            provinceId: 5,
            cantonId: 11,
            id: 4,
            code: 51104,
            name: 'Huacas'
        },
        {
            provinceId: 5,
            cantonId: 11,
            id: 5,
            code: 51105,
            name: 'Matambú'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 1,
            code: 60101,
            name: 'Puntarenas'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 2,
            code: 60102,
            name: 'Pitahaya'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 3,
            code: 60103,
            name: 'Chomes'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 4,
            code: 60104,
            name: 'Lepanto'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 5,
            code: 60105,
            name: 'Paquera'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 6,
            code: 60106,
            name: 'Manzanillo'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 7,
            code: 60107,
            name: 'Guacimal'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 8,
            code: 60108,
            name: 'Barranca'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 9,
            code: 60109,
            name: 'Monte Verde'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 10,
            code: 60110,
            name: 'Isla del Coco'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 11,
            code: 60111,
            name: 'Cóbano'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 12,
            code: 60112,
            name: 'Chacarita'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 13,
            code: 60113,
            name: 'Chira'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 14,
            code: 60114,
            name: 'Acapulco'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 15,
            code: 60115,
            name: 'El Roble'
        },
        {
            provinceId: 6,
            cantonId: 1,
            id: 16,
            code: 60116,
            name: 'Arancibia'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 1,
            code: 60201,
            name: 'Espíritu Santo'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 2,
            code: 60202,
            name: 'San Juan Grande'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 3,
            code: 60203,
            name: 'Macacona'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 4,
            code: 60204,
            name: 'San Rafael'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 5,
            code: 60205,
            name: 'San Jerónimo'
        },
        {
            provinceId: 6,
            cantonId: 2,
            id: 6,
            code: 60206,
            name: 'Caldera'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 1,
            code: 60301,
            name: 'Buenos Aires'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 2,
            code: 60302,
            name: 'Volcán'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 3,
            code: 60303,
            name: 'Potrero Grande'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 4,
            code: 60304,
            name: 'Boruca'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 5,
            code: 60305,
            name: 'Pilas'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 6,
            code: 60306,
            name: 'Colinas'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 7,
            code: 60307,
            name: 'Chánguena'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 8,
            code: 60308,
            name: 'Biolley'
        },
        {
            provinceId: 6,
            cantonId: 3,
            id: 9,
            code: 60309,
            name: 'Brunka'
        },
        {
            provinceId: 6,
            cantonId: 4,
            id: 1,
            code: 60401,
            name: 'Miramar'
        },
        {
            provinceId: 6,
            cantonId: 4,
            id: 2,
            code: 60402,
            name: 'La unión'
        },
        {
            provinceId: 6,
            cantonId: 4,
            id: 3,
            code: 60403,
            name: 'San Isidro'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 1,
            code: 60501,
            name: 'Puerto Cortés'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 2,
            code: 60502,
            name: 'Palmar'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 3,
            code: 60503,
            name: 'Sierpe'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 4,
            code: 60504,
            name: 'Bahía Ballena'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 5,
            code: 60505,
            name: 'Piedras Blancas'
        },
        {
            provinceId: 6,
            cantonId: 5,
            id: 6,
            code: 60506,
            name: 'Bahía Drake'
        },
        {
            provinceId: 6,
            cantonId: 6,
            id: 1,
            code: 60601,
            name: 'Quepos'
        },
        {
            provinceId: 6,
            cantonId: 6,
            id: 2,
            code: 60602,
            name: 'Savegre'
        },
        {
            provinceId: 6,
            cantonId: 6,
            id: 3,
            code: 60603,
            name: 'Naranjito'
        },
        {
            provinceId: 6,
            cantonId: 7,
            id: 1,
            code: 60701,
            name: 'Golfito'
        },
        {
            provinceId: 6,
            cantonId: 7,
            id: 2,
            code: 60702,
            name: 'Puerto Jiménez'
        },
        {
            provinceId: 6,
            cantonId: 7,
            id: 3,
            code: 60703,
            name: 'Guaycará'
        },
        {
            provinceId: 6,
            cantonId: 7,
            id: 4,
            code: 60704,
            name: 'Pavón'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 1,
            code: 60801,
            name: 'San Vito'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 2,
            code: 60802,
            name: 'Sabalito'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 3,
            code: 60803,
            name: 'Aguabuena'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 4,
            code: 60804,
            name: 'Limoncito'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 5,
            code: 60805,
            name: 'Pittier'
        },
        {
            provinceId: 6,
            cantonId: 8,
            id: 6,
            code: 60806,
            name: 'Gutierrez Braun'
        },
        {
            provinceId: 6,
            cantonId: 9,
            id: 1,
            code: 60901,
            name: 'Parrita'
        },
        {
            provinceId: 6,
            cantonId: 10,
            id: 1,
            code: 61001,
            name: 'Corredor'
        },
        {
            provinceId: 6,
            cantonId: 10,
            id: 2,
            code: 61002,
            name: 'La Cuesta'
        },
        {
            provinceId: 6,
            cantonId: 10,
            id: 3,
            code: 61003,
            name: 'Canoas'
        },
        {
            provinceId: 6,
            cantonId: 10,
            id: 4,
            code: 61004,
            name: 'Laurel'
        },
        {
            provinceId: 6,
            cantonId: 11,
            id: 1,
            code: 61101,
            name: 'Jacó'
        },
        {
            provinceId: 6,
            cantonId: 11,
            id: 2,
            code: 61102,
            name: 'Tárcoles'
        },
        {
            provinceId: 6,
            cantonId: 11,
            id: 3,
            code: 61103,
            name: 'Lagunilla'
        },
        {
            provinceId: 6,
            cantonId: 12,
            id: 1,
            code: 61201,
            name: 'Monteverde'
        },
        {
            provinceId: 6,
            cantonId: 13,
            id: 1,
            code: 61301,
            name: 'Puerto Jiménez'
        },
        {
            provinceId: 7,
            cantonId: 1,
            id: 1,
            code: 70101,
            name: 'Limón'
        },
        {
            provinceId: 7,
            cantonId: 1,
            id: 2,
            code: 70102,
            name: 'Valle la Estrella'
        },
        {
            provinceId: 7,
            cantonId: 1,
            id: 3,
            code: 70103,
            name: 'Río Blanco'
        },
        {
            provinceId: 7,
            cantonId: 1,
            id: 4,
            code: 70104,
            name: 'Matama'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 1,
            code: 70201,
            name: 'Guápiles'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 2,
            code: 70202,
            name: 'Jiménez'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 3,
            code: 70203,
            name: 'Rita'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 4,
            code: 70204,
            name: 'Roxana'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 5,
            code: 70205,
            name: 'Cariari'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 6,
            code: 70206,
            name: 'Colorado'
        },
        {
            provinceId: 7,
            cantonId: 2,
            id: 7,
            code: 70207,
            name: 'La Colonia'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 1,
            code: 70301,
            name: 'Siquirres'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 2,
            code: 70302,
            name: 'Pacuarito'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 3,
            code: 70303,
            name: 'Florida'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 4,
            code: 70304,
            name: 'Germania'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 5,
            code: 70305,
            name: 'El Cairo'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 6,
            code: 70306,
            name: 'Alegría'
        },
        {
            provinceId: 7,
            cantonId: 3,
            id: 7,
            code: 70307,
            name: 'Reventazón'
        },
        {
            provinceId: 7,
            cantonId: 4,
            id: 1,
            code: 70401,
            name: 'Bratsi'
        },
        {
            provinceId: 7,
            cantonId: 4,
            id: 2,
            code: 70402,
            name: 'Sixaola'
        },
        {
            provinceId: 7,
            cantonId: 4,
            id: 3,
            code: 70403,
            name: 'Cahuita'
        },
        {
            provinceId: 7,
            cantonId: 4,
            id: 4,
            code: 70404,
            name: 'Telire'
        },
        {
            provinceId: 7,
            cantonId: 5,
            id: 1,
            code: 70501,
            name: 'Matina'
        },
        {
            provinceId: 7,
            cantonId: 5,
            id: 2,
            code: 70502,
            name: 'Batán'
        },
        {
            provinceId: 7,
            cantonId: 5,
            id: 3,
            code: 70503,
            name: 'Carrandi'
        },
        {
            provinceId: 7,
            cantonId: 6,
            id: 1,
            code: 70601,
            name: 'Guácimo'
        },
        {
            provinceId: 7,
            cantonId: 6,
            id: 2,
            code: 70602,
            name: 'Mercedes'
        },
        {
            provinceId: 7,
            cantonId: 6,
            id: 3,
            code: 70603,
            name: 'Pocora'
        },
        {
            provinceId: 7,
            cantonId: 6,
            id: 4,
            code: 70604,
            name: 'Río Jiménez'
        },
        {
            provinceId: 7,
            cantonId: 6,
            id: 5,
            code: 70605,
            name: 'Duacarí'
        }
    ]
};